// The story pages' Project-menu sheets (rooms/plan/menu.ts): the name generator and Suggest Story Times, given the
// menu's context.
import type { MenuContext } from '../../rooms/menus.ts';
import { NameGenerator } from './NameGenerator.tsx';
import { StoryTimeSheet } from './StoryTimeSheet.tsx';

type Props = MenuContext & { onClose(): void };

export function NameGeneratorSheet({ project, live, hrefFor, navigate, onClose }: Props) {
  return (
    <NameGenerator
      project={project}
      live={live}
      onClose={onClose}
      onShow={(id, study) => {
        onClose();
        navigate(hrefFor(study ? 'plan/study' : 'plan/cast', null, { who: id }));
      }}
    />
  );
}

export function StoryTimesSheet({ project, live, onClose }: Props) {
  return <StoryTimeSheet project={project} live={live} onClose={onClose} />;
}
